module.exports = __webpack_public_path__ + "static/img/logo3.b4c1dedd.png";